import React, { useState, useRef, useLayoutEffect, Children } from "react"
import ShowMoreButton from "../atoms/ShowMoreButton"

const ShowMoreFoldable = ({ children, className }) => {
  const refContainer = useRef()
  const [isFoldable, setIsFoldable] = useState(null)
  const [isFolded, setIsFolded] = useState(true)

  useLayoutEffect(() => {
    if (
      Children.toArray(children).length > 0 &&
      refContainer.current.clientHeight > 0 &&
      refContainer.current.scrollHeight > 0
    ) {
      if (
        isFoldable === null &&
        refContainer.current.scrollHeight > refContainer.current.clientHeight
      ) {
        setIsFoldable("true")
      } else if (isFoldable === null) {
        setIsFoldable("false")
      }
    }
  }, [refContainer, isFoldable, children])

  const toggleShowMoreState = (state) => {
    setIsFolded(!state) // invert the bool of "ShowMore"
  }

  return (
    <div className={className?.length > 0 ? className : ""}>
      <div
        ref={refContainer}
        className={`line-clamp-6 ${
          isFoldable === "false" || (isFoldable === "true" && !isFolded)
            ? "block"
            : ""
        }`}
      >
        {children}
      </div>
      {isFoldable === "true" && (
        <ShowMoreButton onStateChange={toggleShowMoreState} />
      )}
    </div>
  )
}

export default ShowMoreFoldable
